var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25959 4.78277L8.11896 9.90973C8.16898 10.2082 8.43874 10.4278 8.75542 10.4278H15.2007C15.5174 10.4278 15.7871 10.2082 15.8372 9.90973L16.6966 4.78277C16.7857 4.25121 16.164 3.87411 15.6977 4.17681L13.9903 5.28505L12.4338 3.79934C12.1822 3.55907 11.7741 3.55907 11.5223 3.79934L9.96585 5.28505L8.25848 4.17681C7.79227 3.87411 7.17043 4.25113 7.25959 4.78277ZM9.68204 6.58886C9.93792 6.75497 10.2814 6.724 10.5002 6.51515L11.9781 5.10446L13.4559 6.51511C13.6748 6.724 14.0182 6.75493 14.2741 6.58882L15.1878 5.99577L14.6511 9.19729H9.30503L8.76839 5.99581L9.68204 6.58886Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9785 3.00391C12.3345 3.00391 12.623 2.72846 12.623 2.38867C12.623 2.04889 12.3345 1.77344 11.9785 1.77344C11.6226 1.77344 11.334 2.04889 11.334 2.38867C11.334 2.72846 11.6226 3.00391 11.9785 3.00391Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4902 3.61914C16.8462 3.61914 17.1348 3.34369 17.1348 3.00391C17.1348 2.66412 16.8462 2.38867 16.4902 2.38867C16.1343 2.38867 15.8457 2.66412 15.8457 3.00391C15.8457 3.34369 16.1343 3.61914 16.4902 3.61914Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 3.61914C7.82276 3.61914 8.11133 3.34369 8.11133 3.00391C8.11133 2.66412 7.82276 2.38867 7.4668 2.38867C7.11083 2.38867 6.82227 2.66412 6.82227 3.00391C6.82227 3.34369 7.11083 3.61914 7.4668 3.61914Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0449 15.3906H15.6595V12.2734C15.6595 11.9337 15.3709 11.6582 15.015 11.6582H8.98501C8.62906 11.6582 8.34048 11.9337 8.34048 12.2734V14.1602H2.95508C2.59912 14.1602 2.31055 14.4356 2.31055 14.7754V22.1582C2.31055 22.498 2.59912 22.7734 2.95508 22.7734H21.0449C21.4009 22.7734 21.6895 22.498 21.6895 22.1582V16.0059C21.6895 15.6661 21.4009 15.3906 21.0449 15.3906ZM3.59961 15.3906H8.34048V21.543H3.59961V15.3906ZM9.62954 12.8887H14.3705V21.543H9.62954V12.8887ZM20.4004 21.543H15.6595V16.6211H20.4004V21.543Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1191H11.3555C10.9995 14.1191 10.7109 14.3946 10.7109 14.7344C10.7109 15.0741 10.9995 15.3496 11.3555 15.3496V17.1953C11.3555 17.5351 11.644 17.8105 12 17.8105C12.356 17.8105 12.6445 17.5351 12.6445 17.1953V14.7344C12.6445 14.3946 12.356 14.1191 12 14.1191Z",
    fill: "#505050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(1 1.77344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/Leaderboard.188b77a21304a9b60e9bb7c7a4150733.svg";
export { ForwardRef as ReactComponent };